import { render, staticRenderFns } from "./CoreItemOne.vue?vue&type=template&id=2511e5ec&scoped=true"
import script from "./CoreItemOne.vue?vue&type=script&lang=js"
export * from "./CoreItemOne.vue?vue&type=script&lang=js"
import style0 from "./CoreItemOne.vue?vue&type=style&index=0&id=2511e5ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2511e5ec",
  null
  
)

export default component.exports